import React, { useState } from "react";
import { Select, MenuItem, Button, Grid, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SelectChangeEvent } from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DocumentType } from "../../../interfaces/document";

interface MovementFilterContentProps {
  onApplyFilter?: (
    state: string | null,
    startDate: Date | null,
    endDate: Date | null
  ) => void;
  status: string | null;
  date: Date | null;
}

const MovementFilterContent: React.FC<MovementFilterContentProps> = ({
  onApplyFilter,
  status,
  date,
}) => {
  const [selectState, setSelectState] = useState<string>(status ?? "ALL");
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(
    date ?? null
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(
    date ?? null
  );

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setSelectState(event.target.value);
  };

  const handleStartDateChange = (date: Date | null) => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date: Date | null) => {
    setSelectedEndDate(date);
  };

  const handleSubmit = () => {
    if (onApplyFilter) {
      const finalState = selectState === "ALL" ? null : selectState;
      onApplyFilter(finalState, selectedStartDate, selectedEndDate);
    }
  };

  return (
    <Grid container spacing={2} p={3}>
      <Grid item xs={12}>
        <Typography variant="h6" fontSize="1rem" mb={1}>
          Tipo:
        </Typography>
        <Select fullWidth value={selectState} onChange={handleSelectChange}>
          <MenuItem value="ALL">Entrambi</MenuItem>
          <MenuItem value={DocumentType.ACCEPTANCE}>Carico</MenuItem>
          <MenuItem value={DocumentType.DISPATCH}>Scarico</MenuItem>
        </Select>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6" fontSize="1rem" mb={1}>
          Da Data:
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={"Seleziona una data"}
            value={selectedStartDate}
            onChange={(date) => handleStartDateChange(date)}
            sx={{ width: "100%" }}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6" fontSize="1rem" mb={1}>
          A Data:
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={"Seleziona una data"}
            value={selectedEndDate}
            onChange={(date) => handleEndDateChange(date)}
            sx={{ width: "100%" }}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} textAlign="end">
        <Button fullWidth variant="contained" onClick={handleSubmit}>
          Applica filtro
        </Button>
      </Grid>
    </Grid>
  );
};

export default MovementFilterContent;
